export default __webpack_public_path__ + "static/ti_hovermotorhome_block-42d1a62c8240a6dadad7a44d939a0182.svg";